import React from 'react';
import { Th } from '../../../../components/Tbl';

const RowHeader = props => (
  <tr>
    <Th>No.</Th>
    <Th>Order Detail</Th>
    <Th>Awb numb.</Th>
    <Th>Price</Th>
    <Th>Payment</Th>
    <Th>Updated</Th>
    <Th>Action</Th>
  </tr>
)

export default RowHeader;